import client from './client';

export interface DebtSummary {
  id: number;
  name: string;
  totalVolume: number;
  totalValue: number;
  paidAmount: number;
  outstandingAmount: number;
  tripCount: number;
}

export interface EntityDebt {
  entityId: number;
  totalVolume: number;
  totalValue: number;
  paidAmount: number;
  outstandingAmount: number;
  tripCount: number;
}

export const debtAPI = {
  // Supplier Debts
  getSupplierDebts: async (all: boolean = false): Promise<DebtSummary[]> => {
    const response = await client.get('/debt/suppliers', {
      params: all ? { all: 'true' } : undefined,
    });
    return response.data.data;
  },

  getSupplierDebt: async (supplierId: number): Promise<EntityDebt> => {
    const response = await client.get(`/debt/suppliers/${supplierId}`);
    return response.data.data;
  },

  // Customer Debts
  getCustomerDebts: async (all: boolean = false): Promise<DebtSummary[]> => {
    const response = await client.get('/debt/customers', {
      params: all ? { all: 'true' } : undefined,
    });
    return response.data.data;
  },

  getCustomerDebt: async (customerId: number): Promise<EntityDebt> => {
    const response = await client.get(`/debt/customers/${customerId}`);
    return response.data.data;
  },
};
